import { css } from "@emotion/react";
import styled from "@emotion/styled";
import * as React from "react";
import { Link } from "react-router-dom";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon/Icon";
import { withVar } from "themes/helpers";

/**
 * Dropdown Menu Item
 *
 * @example
 *   <DropdownMenuItem to="url"></DropdownMenuItem>
 *   <DropdownMenuItem onClick={callback}></DropdownMenuItem>
 */

const commonCss = css`
  position: relative;
  display: block;
  width: 100%;
  height: 36px;
  line-height: 35px;
  padding: 0 40px 0 13px;

  color: ${withVar(DesignToken.ContentBasicPrimary)};
  text-align: left;
  cursor: pointer;

  border: none;
  background-color: transparent;
  box-sizing: border-box;

  svg {
    width: 100%;
  }

  path {
    fill: ${withVar(DesignToken.ActionPrimaryDefault)};
  }

  &:active,
  &:focus {
    outline: none;
  }

  &:hover,
  &:active {
    color: ${withVar(DesignToken.ContentInvertPrimary)};
    background-color: ${withVar(DesignToken.ActionPrimaryDefault)};
    text-decoration: none;
    path {
      fill: ${withVar(DesignToken.ContentInvertPrimary)};
    }
  }
`;
export const AnchorContainer = styled(Link)`
  text-decoration: none;
  ${commonCss};
`;

const ButtonContainer = styled.button`
  ${commonCss}
`;

const DropdownIcon = styled.span`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const DropdownIconPush = styled.span`
  margin-right: 32px;
`;

interface IProps {
  children: React.ReactNode;
  iconName?: IconsEnum;
  to?: string;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
}

const DropdownMenuItem: React.FC<IProps> = props => {
  const hasIcon = props.iconName != null;

  const childElements = (
    <>
      {hasIcon && (
        <DropdownIcon>
          {/* @ts-expect-error TS(2322) */}
          <Icon name={props.iconName} inline />
        </DropdownIcon>
      )}
      {hasIcon && <DropdownIconPush />}
      {props.children}
    </>
  );

  if (props.to) {
    return <AnchorContainer to={props.to}>{childElements}</AnchorContainer>;
  }
  return <ButtonContainer onClick={props.onClick}>{childElements}</ButtonContainer>;
};

export default DropdownMenuItem;
